class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(tab));
    });

    const preselected = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
    this.selectTab(preselected || this.tabs[0]);
  }

  selectTab(selectedTab) {
    if (!selectedTab) return;

    this.tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', tab === selectedTab ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
    });
  }
}

customElements.define('product-tabs', ProductTabs);
